export default {
  install (Vue, io) {
    Vue.mixin({
      created: function () {
        this.$io = io
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/vue-sails/index.js